import { FlaskConical, Save } from "lucide-react";
import React, { useState } from "react";

import SplitButtonNew from "./SplitButtonNew";

const SplitButtonNewExample: React.FC = () => {
	const [last, setLast] = useState("–");

	return (
		<div className="max-w-2xl space-y-8 p-6">
			<h3 className="text-lg font-semibold">SplitButtonNew</h3>
			<p className="text-sm text-gray-600">
				A primary action with a chevron that opens a menu of secondary actions, in the same variants
				as ButtonNew. The segments are separate buttons, so the menu stays usable when the primary
				action is disabled and the other way around.
			</p>
			<p className="text-sm text-gray-600">Last action: {last}</p>

			<div>
				<h4 className="mb-2 font-medium">Variants</h4>
				<div className="flex flex-wrap items-center gap-3">
					<SplitButtonNew
						variant="primary"
						onClick={() => setLast("Skapa fakturor")}
						menuLabel="Fler alternativ"
						items={[
							{
								label: "Testkör",
								icon: <FlaskConical />,
								onSelect: () => setLast("Testkör"),
							},
						]}
					>
						Skapa fakturor
					</SplitButtonNew>
					<SplitButtonNew
						variant="dark"
						onClick={() => setLast("Spara")}
						items={[
							{ label: "Spara som ny", icon: <Save />, onSelect: () => setLast("Spara som ny") },
							{ label: "Spara och stäng", onSelect: () => setLast("Spara och stäng") },
						]}
					>
						Spara
					</SplitButtonNew>
					<SplitButtonNew
						variant="neutral"
						onClick={() => setLast("Exportera")}
						items={[{ label: "Exportera som CSV", onSelect: () => setLast("CSV") }]}
					>
						Exportera
					</SplitButtonNew>
					<SplitButtonNew
						variant="danger"
						onClick={() => setLast("Ta bort")}
						items={[{ label: "Arkivera i stället", onSelect: () => setLast("Arkivera") }]}
					>
						Ta bort
					</SplitButtonNew>
				</div>
			</div>

			<div>
				<h4 className="mb-2 font-medium">Primary disabled, menu still open</h4>
				<SplitButtonNew
					disabled
					onClick={() => setLast("Skapa fakturor")}
					items={[{ label: "Testkör", icon: <FlaskConical />, onSelect: () => setLast("Testkör") }]}
				>
					Skapa fakturor
				</SplitButtonNew>
			</div>

			<div>
				<h4 className="mb-2 font-medium">Every item disabled disables the chevron</h4>
				<SplitButtonNew
					onClick={() => setLast("Skapa fakturor")}
					items={[{ label: "Testkör", disabled: true, onSelect: () => setLast("Testkör") }]}
				>
					Skapa fakturor
				</SplitButtonNew>
			</div>

			<div>
				<h4 className="mb-2 font-medium">No items renders a plain button</h4>
				<SplitButtonNew onClick={() => setLast("Skapa fakturor")} items={[]}>
					Skapa fakturor
				</SplitButtonNew>
			</div>
		</div>
	);
};

export default SplitButtonNewExample;
